<script lang="ts">
  // *** This file is part of DbGate Premium ***

  import SelectField from '../forms/SelectField.svelte';

  export let label;
  export let options;
  export let value;
  export let setValue: (value: any) => void;
</script>

<div class="m-3 mb-0">{label}:</div>
<SelectField
  selectClass="mx-3 my-1"
  isNative
  {options}
  {value}
  data-testid={$$props['data-testid']}
  on:change={e => {
    setValue(e.detail);
  }}
/>
